import { useState, useEffect } from 'react';
import { supabase } from '../../lib/supabase';
import toast from 'react-hot-toast';
import './Admin.css';

export default function AdminProfile() {
  const [avatarUrl, setAvatarUrl] = useState('');
  const [loading, setLoading] = useState(true);
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    supabase
      .from('site_settings')
      .select('avatar_url')
      .eq('id', 'main')
      .single()
      .then(({ data }) => {
        setAvatarUrl(data?.avatar_url || '');
        setLoading(false);
      });
  }, []);

  const saveAvatarUrl = async (url) => {
    const { error } = await supabase
      .from('site_settings')
      .upsert({ id: 'main', avatar_url: url, updated_at: new Date().toISOString() });
    return error;
  };

  const handleUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);

    const ext = file.name.split('.').pop();
    const path = `profile/avatar-${Date.now()}.${ext}`;
    const { error: uploadError } = await supabase.storage
      .from('blog-images')
      .upload(path, file, { upsert: true });

    if (uploadError) {
      toast.error('Image upload failed: ' + uploadError.message);
      setUploading(false);
      return;
    }

    const { data } = supabase.storage.from('blog-images').getPublicUrl(path);
    const saveError = await saveAvatarUrl(data.publicUrl);

    setUploading(false);

    if (saveError) {
      toast.error('Could not save profile picture: ' + saveError.message);
      return;
    }

    setAvatarUrl(data.publicUrl);
    toast.success('Profile picture updated!');
  };

  const handleRemove = async () => {
    const error = await saveAvatarUrl(null);
    if (error) {
      toast.error(error.message);
      return;
    }
    setAvatarUrl('');
    toast.success('Profile picture removed');
  };

  if (loading) {
    return (
      <div className="admin-page">
        <p className="admin-state-msg">Loading...</p>
      </div>
    );
  }

  return (
    <div className="admin-page">
      <div className="admin-page-header">
        <h1>Profile</h1>
      </div>

      <div className="admin-section">
        <h2>Profile Picture</h2>
        <p className="admin-state-msg" style={{ padding: '0 0 1.25rem' }}>
          Shown next to your name on every blog post.
        </p>

        <div className="profile-picture-row">
          <div className="profile-picture-preview">
            {avatarUrl ? <img src={avatarUrl} alt="Profile" /> : <span>K</span>}
          </div>

          <div className="profile-picture-actions">
            <label className={`btn-admin-ghost${uploading ? ' uploading' : ''}`}>
              <input
                type="file"
                accept="image/*"
                onChange={handleUpload}
                disabled={uploading}
                hidden
              />
              {uploading ? 'Uploading…' : avatarUrl ? 'Change picture' : 'Upload picture'}
            </label>
            {avatarUrl && !uploading && (
              <button type="button" className="btn-admin-danger" onClick={handleRemove}>
                Remove
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
